<template>
  <div>
    <div class="p-grid p-justify-center" style="padding-top: 50px">
      <div class="p-col-fixed singin-content">
        <div class="p-grid p-justify-center">
          <div class="p-col-12">
            <div class="p-grid">
              <div class="p-col-12">
                <div class="header-logo">
                  <span>
                      mf.availability
                  </span>
                </div>
              </div>
              <div class="p-col-12">
                <div class="header">
                  Sign in
                </div>
              </div>
              <div class="p-col-12">
                <div class="p-grid p-fluid">
                  <div class="p-col-12" style="margin-left: 5px">
                    <label for="username">Username:</label>
                  </div>
                  <div class="p-col-12">
                    <InputText id="username" v-model="user.username" placeholder="username"></InputText>
                  </div>
                </div>
                <div class="p-grid p-fluid">
                  <div class="p-col-12" style="margin-top: 15px; margin-left: 5px">
                    <label for="password">Password:</label>
                  </div>
                  <div class="p-col-12">
                    <Password id="password" v-model="user.password" :feedback="false"
                              placeholder="password"></Password>
                  </div>
                </div>
              </div>
              <div class="p-col-12" style="margin-top: 15px">
                <div class="p-grid p-fluid">
                  <div class="p-col-12">
                    <Button :label="translate('button.anmelden')" v-on:click="anmelden"></Button>
                  </div>
                </div>
              </div>
              <div class="p-col-12" style="border-top: 1px solid lightgray; margin-top: 15px">
                In this test version no login is needed you can proceed by hitting the Sign in button.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {User} from "../../models/user";
import TranslateService from "../../services/translate.service";
// import Vue from 'vue';
// import KeycloakService from "@/services/keycloak.service";
// import _ from 'lodash';

export default {
  name: "KeycloakLogin",
  data() {
    return {
      user: new User("", ""),
    }
  },
  computed: {
    ...mapGetters('auth', ['isAuthenticated']),
  },
  methods: {
    ...mapActions('auth', [
      'keycloakLogin'
    ]),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    anmelden() {
      // KeycloakService.keycloak.
    },
    checkSso() {
      if (this.isAuthenticated) {
        this.$router.push("/");
      }
    }
  },
  mounted() {
    this.checkSso()
  }
}
</script>

<style scoped>

</style>